import { combineReducers } from 'redux';
import authenticationReducer from './authentication/authentication.reducer';
import warrantsReducer from '../xcipio/warrants/warrants-reducer';
import usersReducer from '../users/users-reducer';
import teamsReducer from '../teams/teams-reducer';
import roleReducer from '../roles/roles-reducer';
import securityPolicyReducer from './securityPolicy/securityPolicy.reducer';
import policiesReducer from '../policies/policy-reducer';
import auditReducer from '../audit/general-audit/audit-reducer';
import userAuditReducer from './userAudit/user-audit.reducer';
import accessFunctionReducer from './accessFunction/accessFunction.reducer';
import collectionFunctionReducer from './collectionFunction/collectionFunction.reducer';
import casesReducer from '../xcipio/cases/case-reducer';
import targetReducer from '../xcipio/targets/targets-reducer';
import attachmentsReducer from '../xcipio/attachments/attachments-reducer';
import wiretapsReducer from '../xcipio/wiretaps/wiretap-reducer';
import contactsReducer from './contact/contact.reducer';
import distributorConfigurationReducer from './distributorConfiguration/distributorConfiguration.reducer';
import globalReducer from '../global/global-reducer';
import iriBufferingReducer from './iriBuffering/iriBuffering.reducer';
import discoveryXcipioReducer from '../xcipio/discovery-xcipio-reducer';
import distributorReducer from './distributor/distributor.reducer';
import nodesReducer from './nodes/nodes.reducer';
import networkReducer from './network/network.reducer';
import securityInfoReducer from './securityInfo/securityInfo.reducer';
import sshSecurityInfoReducer from './sshSecurityInfo/sshSecurityInfo.reducer';
import locationReducer from './location/location.reducer';
import tlsProxyReducer from './tlsProxy/tlsProxy.reducer';
import ss8ProxyDefaultReducer from './ss8ProxyDefault/ss8ProxyDefault.reducer';
import fqdnGroupReducer from './fqdnGroup/fqdnGroup.reducer';
import vpnConfigReducer from './vpnConfig/vpnConfig.reducer';
import vpnConfigTemplateReducer from './vpnTemplate/vpnTemplate.reducer';
import xtpReducer from './xtp/xtp.reducer';
import xdpReducer from './xdp/xdp.reducer';
import processOptionReducer from './processOption/processOption.reducer';
import registeredNodeReducer from './registeredNode/registeredNode.reducer';
import alertNotificationReducer from './alertNotification/alertNotification.reducer';
import collectionFunctionGroupReducer from './collectionFunctionGroup/collectionFunctionGroup.reducer';
import dialedDigitExtractionServerReducer from './dialedDigitExtractionServer/dialedDigitExtractionServer.reducer';
import deliveryFunctionNetworkInterfaceReducer from './deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.reducer';
import utimacoPacketSwitchReducer from './utimacoPacketSwitch/utimacoPacketSwitch.reducer';
import targetDeliveryTemplateAccessFunctionReducer from './targetDeliveryTemplateAccessFunction/targetDeliveryTemplateAccessFunction.reducer';
import networkIdReducer from './networkId/networkId.reducer';
import tlsProfileReducer from './tlsProfile/tlsProfile.reducer';
import targetDomainReducer from './targetDomain/targetDomain.reducer';
import periodicAuditReducer from './periodicAudit/periodicAudit.reducer';
import natConfigurationReducer from './natConfiguration/natConfiguration.reducer';
import jurisdictionAreaReducer from './jurisdictionArea/jurisdictionArea.reducer';
import cfFtpInfoReducer from './cfFtpInfo/cfFtpInfo.reducer';
import filterGroupReducer from './filterGroup/filterGroup.reducer';
import afFilterReducer from './afFilter/afFilter.reducer';
import filtersReducer from './filters/filters.reducer';
import radiusParserOptionsReducer from './radiusParserOptions/radiusParserOptions.reducer'
import sipSettingReducer from './sipSetting/sipSetting.reducer';
import fqdnReducer from './fqdn/fqdn.reducer';
import xtpXdpConnectionReducer from './xtp-xdp-connection/xtp-xdp-connection.reducer';
import radiusParserPasswordReducer from './radiusParserPassword/radiusParserPassword.reducer';
import networkTopologyReducer from './network-topology/network-topology.reducer';
import diameterReducer from './diameter/diameter.reducer';
import logReducer from './log/log.reducer';
import backupReducer from './backupRestore/backup.reducer';
import mediaGatewayReducer from './mediaGateway/mediaGateway.reducer';
import alarmReducer from './alarm/alarm.reducer';
import alarmNotificationProfileReducer from './alarmNotificationProfile/alarmNotificationProfile.reducer';
import utimacoCircuitSwitchReducer from './utimacoCircuitSwitch/utimacoCircuitSwitch.reducer';
import afWhitelistReducer from './afWhitelist/afWhitelist.reducer'
import certStatusReducer from './certStatus/certStatus.reducer';
import snmpReducer from './snmp/snmp.reducer';
import eWarrantReducer from './eWarrant/eWarrant.reducer';
import cspConfigReducer from './cspConfig/cspConfig.reducer';

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  warrants: warrantsReducer,
  users: usersReducer,
  teams: teamsReducer,
  roles: roleReducer,
  securityPolicy: securityPolicyReducer,
  policies: policiesReducer,
  audit: auditReducer,
  userAudit: userAuditReducer,
  afs: accessFunctionReducer,
  cfs: collectionFunctionReducer,
  collectionFunctionGroup: collectionFunctionGroupReducer,
  discoveryXcipio: discoveryXcipioReducer,
  cases: casesReducer,
  targets: targetReducer,
  attachments: attachmentsReducer,
  wiretaps: wiretapsReducer,
  contacts: contactsReducer,
  distributorConfiguration: distributorConfigurationReducer,
  global: globalReducer,
  distributor: distributorReducer,
  nodes: nodesReducer,
  network: networkReducer,
  securityInfo: securityInfoReducer,
  sshSecurityInfo: sshSecurityInfoReducer,
  vpnConfig: vpnConfigReducer,
  fqdnGroup: fqdnGroupReducer,
  vpnConfigTemplate: vpnConfigTemplateReducer,
  location: locationReducer,
  tlsProxy: tlsProxyReducer,
  iriBuffering: iriBufferingReducer,
  ss8ProxyDefault: ss8ProxyDefaultReducer,
  xtp: xtpReducer,
  xdp: xdpReducer,
  registeredNode: registeredNodeReducer,
  processOption: processOptionReducer,
  alertNotification: alertNotificationReducer,
  dialedDigitExtractionServer: dialedDigitExtractionServerReducer,
  tlsProfile: tlsProfileReducer,
  certStatus: certStatusReducer,
  periodicAudit: periodicAuditReducer,
  deliveryFunctionNetworkInterface: deliveryFunctionNetworkInterfaceReducer,
  utimacoPacketSwitch: utimacoPacketSwitchReducer,
  utimacoCircuitSwitch: utimacoCircuitSwitchReducer,
  targetDeliveryTemplateAccessFunction: targetDeliveryTemplateAccessFunctionReducer,
  networkId: networkIdReducer,
  targetDomain: targetDomainReducer,
  natConfiguration: natConfigurationReducer,
  jurisdictionArea: jurisdictionAreaReducer,
  cfFtpInfo: cfFtpInfoReducer,
  filterGroup: filterGroupReducer,
  afFilter: afFilterReducer,
  filters: filtersReducer,
  sipSetting: sipSettingReducer,
  radiusParserOptions: radiusParserOptionsReducer,
  fqdn: fqdnReducer,
  xtpXdpConnection: xtpXdpConnectionReducer,
  radiusParserPassword: radiusParserPasswordReducer,
  networkTopology: networkTopologyReducer,
  diameter: diameterReducer,
  logs: logReducer,
  backupFile: backupReducer,
  mediaGateway: mediaGatewayReducer,
  alarms: alarmReducer,
  alarmNotificationProfile: alarmNotificationProfileReducer,
  afWhitelist: afWhitelistReducer,
  snmp: snmpReducer,
  eWarrant: eWarrantReducer,
  cspConfig: cspConfigReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>
